export const all_routes = {
  ionicicons: "/icon-ionic",
  materialicons: "/icon-material",
  pe7icons: "/icon-pe7",
  simpleline: "/icon-simpleline",
  themifyicons: "/icon-themify",
  iconweather: "/icon-weather",
  typicons: "/icon-typicon",
  flagicons: "/icon-flag",
  remixIcon: "/remix-icon",
  BootstrapIcon: "/bootstrap-icon",
  TablerIcon: "/tabler-icon",

  //region auth
  signin: "/signin",
  forgotPassword: "/forgot-password",

  //region layput demo
  Horizontal: "/layout-horizontal",
  Detached: "/layout-detached",
  Hovered: "/layout-hovered",
  Boxed: "/layout-box",
  Modern: "/layout-modern",
  TwoColumn: "/layout-two-column",
  Dark: "/layout-dark",
  RTL: "/layout-rtl",

  //region RollCall
  rollcalldashboard: "/rollcall/dashboard",
  rollcallkpidashboard: "/rollcall/kpidashboard",
  rollcallattendance: "/rollcall/attendance",
  rollcallleaveslist: "/rollcall/leaves",
  rollcallteammembers: "/rollcall/teammembers",
  rollcallleaveapplication: "/rollcall/leaveapplication",
  rollcallteamattendance: "/rollcall/teamattendance",
  rollcallmanualattendance: "/rollcall/manualattendance",
  rollcallbulkattendance: "/rollcall/bulkattendance",
  rollcallleavesummary: "/rollcall/leavesummary",

  rollcallleaveaccurals: "/rollcall/leaveaccurals",
  rollcallleavetypes: "/rollcall/leavetypes",
  rollcallnotification: "/rollcall/notification",

  // visting new
  rollcallvisitorlist: "/visitor/visitorlist",
  rollcallvisitorreport: "/visitor/visitorreport",
};
